import { useState, useEffect } from "react";
import { getAllEndpoints } from "../services/workflowService";

// Module cache — the catalog rarely changes within a session and is heavy to
// fetch, so we only pull it once.
let cache = null;

/** Flat endpoint catalog for the Studio's endpoint picker. */
export const useEndpoints = () => {
  const [endpoints, setEndpoints] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) return;
    let alive = true;
    (async () => {
      const res = await getAllEndpoints();
      if (!alive) return;
      if (res.success && Array.isArray(res.data)) {
        cache = res.data;
        setEndpoints(res.data);
      }
      setLoading(false);
    })();
    return () => {
      alive = false;
    };
  }, []);

  return { endpoints, loading };
};
